import { render, staticRenderFns } from "./TripsOverview.vue?vue&type=template&id=b0dd31b0&scoped=true&"
import script from "./TripsOverview.vue?vue&type=script&lang=ts&"
export * from "./TripsOverview.vue?vue&type=script&lang=ts&"
import style0 from "./TripsOverview.vue?vue&type=style&index=0&id=b0dd31b0&prod&lang=scss&scoped=true&"
import style1 from "./TripsOverview.vue?vue&type=style&index=1&id=b0dd31b0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0dd31b0",
  null
  
)

export default component.exports